import React from 'react';
import {
    List,
    Edit,
    Datagrid,
    SimpleForm,
    TextField,
    TextInput,
//    RichTextField,
//     EditButton,
    Filter,
    ReferenceInput,
    DateInput,
    FunctionField,
    AutocompleteInput,
    Pagination,
    // required
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ToggleableEnabledStateField from "./fields/TogglableField";
import DirectorySelectInput from "./input/DirectorySelectInput";
// import {IsAdmin} from "./roleChecker";
import beautyCountry from "./helpers/beautyCountryRow";
import ExcelJS from "exceljs";
import {
    RoomsAndRatePlans,
    Owner,
    YavdomaHotelURL,
    HotelDeleteFromYavdoma,
    HotelNotesEditButton,
    handleDeleteHotelFromExtranet,
    useTooltipStyles
} from "./helpers/hotelsHelper";
const countryRenderer = choice => (choice.name ? beautyCountry(choice.name) : null);


const AdminHotelsFilter = props => (
    <Filter {...props}>
        <TextInput source="title" label="Назва" alwaysOn/>
        <DirectorySelectInput source="type" dirname="hotel_types" label="Тип"/>
        <DirectorySelectInput source="provider" dirname="providers" label="Провайдер" alwaysOn/>
        <DateInput source="externalCreatedAt" label="Дата реєстрації готеля"/>
        <DirectorySelectInput source="stars" dirname="stars" label="Зірки"/>
        <ReferenceInput label="Місто" source="city" reference="hotels/cities"
                        filterToQuery={searchText => ({term: searchText})}>
            <AutocompleteInput optionText="name" helperText={false}/>
        </ReferenceInput>
        <ReferenceInput label="Країна" source="countryCode" reference="hotels/countries"
                        filterToQuery={searchText => ({term: searchText})}>
            <AutocompleteInput optionText={countryRenderer} helperText={false}/>
        </ReferenceInput>
    </Filter>
);


const exportData = posts => {
    const workBook = new ExcelJS.Workbook();
    const sheet = workBook.addWorksheet('My sheet');

    sheet.columns = [
        {
            header: 'Назва',
            key: 'hotelTitle',
            width: 30
        },
        {
            header: 'Ext ID',
            key: 'externalId',
            width: 20
        },
        {
            header: 'Тип',
            key: 'hotelType',
            width: 20
        },
        {
            header: 'Зірки',
            key: 'hotelStars',
            width: 10
        },            {
            header: 'Країна',
            key: 'hotelCountry',
            width: 20
        },            {
            header: 'Місто',
            key: 'hotelCity',
            width: 20
        },            {
            header: 'Адреса',
            key: 'hotelAddress',
            width: 30
        },
        {
            header: 'Мейл, Телефон',
            key: 'hotelMailPhone',
            width: 30
        },            {
            header: 'Особа',
            key: 'hotelContactPerson',
            width: 30
        },
        {
            header: "Якщо є 'галочка', то готель опубліковано на сайті",
            key: 'hotelEnabled',
            width: 10
        },
        {
            header: 'Провайдер',
            key: 'hotelProvider',
            width: 10
        },
        {
            header: 'Дата реєстрації готеля',
            key: 'externalCreatedAt',
            width: 10
        },
        {
            header: 'Примітки',
            key: 'hotelNote',
            width: 10
        },
        {
            header: 'Маржа',
            key: 'hotelExtraCharge',
            width: 10
        },
        {
            header: 'Yavdoma hotel URL',
            key: 'yavdoma_URL',
            width: 80
        }
    ];

    posts.forEach(post => {
        sheet.addRow({
            hotelTitle: post.title,
            externalId: post.external_id,
            hotelType: post.type,
            hotelStars: post.stars,
            hotelCountry: (post.country_code ? beautyCountry(post.country_code) : null),
            hotelCity: post.city,
            hotelAddress: post.address,
            hotelMailPhone: (post.contacts ?`${post.contacts.mail} , ${post.contacts.phone}` : ''),
            hotelContactPerson: post.owner,
            hotelEnabled: post.enabled,
            hotelProvider: post.provider,
            externalCreatedAt: post.external_created_at,
            hotelNote: post.note,
            hotelExtraCharge: (post.extra_charge ? `${post.extra_charge.title}` : null),
            yavdoma_URL: `${process.env.REACT_APP_YAVDOMA_URL+'/ua/hotels/'+post.id}`
        });
    });

    workBook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheet.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'Hotels.xlsx';
        anchor.click();
        window.URL.revokeObjectURL(url);
    });
}


const AdminHotelsPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const AdminHotelsList = ({permissions, ...props}) => (
    <List filters={<AdminHotelsFilter/>} bulkActionButtons={false} pagination={<AdminHotelsPagination />} {...props} exporter={exportData}>
        <Datagrid rowClick="">
            <TextField source="title" label="Назва"/>
            <TextField source="external_id" label="Ext ID"/>
            <RoomsAndRatePlans {...props} label='Rooms and rate plans'/>
            <TextField source="city" label="Місто"/>
            <Owner {...props} label='Хто зареєстрував готель' />
            <FunctionField label="Мейл, Телефон готельного об'єкта"
                           render={record => (record.hotel_insite_contacts[0] ? beautyCountry(record.hotel_insite_contacts[0].email + ' ' +record.hotel_insite_contacts[0].phoneNumber) : null)}/>
            <HotelDeleteFromYavdoma {...props} label='Видалити готель з БД Yavdoma.com' />
            <FunctionField source="delete_extranet"
                label="Видалити готель з БД Extranet"
                headerClassName="delete-extranet-header"
                render={record => (
                    record.provider === 'extranet'
                        ? <button onClick={() => handleDeleteHotelFromExtranet(record)}>Delete</button>
                        : null
             )}/>
            <ToggleableEnabledStateField  sortable={false} source="enabled" label={ <DeleteExtranetLabel /> } />
            <YavdomaHotelURL label="Yavdoma hotel URL" {...props} />
            <FunctionField source="externalCreatedAt"
                           render={record => (record.external_created_at ? (new Date(record.external_created_at)).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }) : null)}
                           label="Дата реєстрації готеля"/>
            <HotelNotesEditButton label="Примітки" />
            <TextField source="stars" label="Зірки"/>
            <TextField source="address" label="Адреса"/>
        </Datagrid>
    </List>
);

export const AdminHotelsEdit = ({permissions, ...props}) => {
    return <Edit {...props}>
        <SimpleForm>
            {/*<TextInput source="contacts.email" label="Мейл" validate={required()}/>*/}
            {/*<TextInput source="contacts.phone" label="Телефон" validate={required()}/>*/}
            {/*<TextInput source="contact_person" label="Особа"/>*/}
            <RichTextInput source="note" label="Примітки"/>
            {/*{*/}
            {/*    IsAdmin(permissions) &&*/}
            {/*    <ReferenceInput label="Маржа" source="extra_charge.id" reference="extra-charges"*/}
            {/*                    filterToQuery={searchText => ({title: searchText})} validate={required()}>*/}
            {/*        <AutocompleteInput optionText="title"/>*/}
            {/*    </ReferenceInput>*/}
            {/*}*/}
            <FunctionField addLabel={false} render={record => record.owner && record.owner.userIdentifier ? <div>
                <div><strong>Extranet User</strong></div>
                <div><strong>Id:</strong> <FunctionField
                    render={record => (record.owner ? record.owner.userIdentifier : null)}
                    label="Id"/></div>
                <div><strong>First name:</strong> <FunctionField
                    render={record => (record.owner ? record.owner.firstName : null)}
                    label="First name"/></div>
                <div><strong>Last name:</strong> <FunctionField
                    render={record => (record.owner ? record.owner.lastName : null)}
                    label="Last name"/></div>
                <div><strong>Phone Number:</strong> <FunctionField
                    render={record => (record.owner ? record.owner.phoneNumber : null)}
                    label="Phone Number"/></div>
                <div><strong>Email:</strong> <FunctionField
                    render={record => (record.owner ? record.owner.email : null)}
                    label="Email"/></div>
                <div><strong>Is Verified:</strong> <FunctionField
                    render={record => (record.owner && record.owner.isVerified ? 'True' : 'False')}
                    label="Is Verified"/></div>
                <div><strong>Hotel IDs:</strong> <FunctionField
                    render={record => (record.owner && record.owner.hotelIds?.length ? record.owner.hotelIds.join(', ') : null)}
                    label="Hotel IDs"/></div>
            </div> : <div></div>}/>
        </SimpleForm>
    </Edit>
};

const DeleteExtranetLabel = () => {
    const classes = useTooltipStyles();

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Tooltip
                title="Якщо є 'галочка', то готель опубліковано на сайті"
                arrow
                classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow,
                }}
            >
                <HelpOutlineIcon
                    style={{
                        fontSize: 20,
                        marginLeft: 4,
                        cursor: 'pointer',
                    }}
                />
            </Tooltip>
        </span>
    );
};
